/**
 * Internal dependencies
 */
import * as actions from 'state/action-types';

import { createReducer } from 'state/utils';

const step = createReducer(null, {
	[actions.REPORT_BUILDER_GO_TO_STEP]: (state, action) => {
		return state;
	},
	[actions.REPORT_BUILDER_GO_TO_NEXT_STEP]: (state, action) => {
		return state;
	},
});

export default step;
